/* import __COLOCATED_TEMPLATE__ from './decide.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();